import React, { useState, useEffect } from 'react';

export const useUtcButtonState = () => {
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    const checkTimeAndUpdateButton = () => {
      const now = new Date();
      
      const istOffset = 5.5 * 60 * 60 * 1000;
      const istTime = new Date(now.getTime() + istOffset);
      const istHours = istTime.getUTCHours();
      const istMinutes = istTime.getUTCMinutes();
      
      const timeString = `${istHours.toString().padStart(2, '0')}:${istMinutes.toString().padStart(2, '0')} IST`;
      setCurrentTime(timeString);
      
      const isEnabled = istHours >= 16 || istHours < 8;
      setIsButtonEnabled(isEnabled);
    };

    checkTimeAndUpdateButton();

    const interval = setInterval(checkTimeAndUpdateButton, 60000);

    return () => clearInterval(interval);
  }, []);

  return { isButtonEnabled, currentTime };
};